import { Component, Input, OnInit } from "@angular/core";
import { ShareService } from "../service/share.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { NgbNav } from "@ng-bootstrap/ng-bootstrap";
import { MatDialog } from "@angular/material/dialog";
import { EnquiryPopupComponent } from "./EnquiryPopup/enquiry-popup/enquiry-popup.component";
import { kesariAnimations } from "../animation";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: "app-mice-country-state",
  templateUrl: "./mice-country-state.component.html",
  styleUrls: ["./mice-country-state.component.scss"],
  animations: kesariAnimations,
})
export class MiceCountryStateComponent implements OnInit {
  itinenary: any;
  countries: string;
  countyIti: any[];
  countryArray: [];
  uniqueCountryArray: any;
  itinerariesCountry: any[];
  selectedCountry: string;
  itinerariesCountryObj: {};
  selectedIndex = 0;
  downloadD = [];
  nav: NgbNav;
  metaData = {
    isProduct: false,
    page: "MICE-ITINERARIES"
  }
  constructor(
    private miceService: ShareService,
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getItinerary();
    // this.selectedCountry = this.uniqueCountryArray[0];
  }

  getItinerary() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const itemwithdash = "-";
      const replaceWithempty = " ";
      this.countries = params
        .get("state")
        .split(itemwithdash)
        .join(replaceWithempty);
      this.countyIti = [];
      this.itinerariesCountry = [];
      this.itinerariesCountryObj = {};
      // console.log(this.countries, "hey there I'm using WhatsApp");
      this.miceService.getItinerary().subscribe((data) => {
        //    console.log(data);
        this.itinenary = data;
        //  console.log(this.itinenary[0].country, "heyyy");
        this.countryArray = this.itinenary.map((item) => item.country);
        this.uniqueCountryArray = [
          ...new Set(
            this.countryArray.filter((country) => country !== undefined)
          ),
        ];
        // console.log(this.uniqueCountryArray);
        this.selectedCountry = this.countries;
        //console.log(this.selectedCountry, "hello ");
      });
    });
    this.miceService.getMetaData(this.metaData).subscribe((data) => {
      // console.log(data)
      if (data.length != 0) {
        this.meta.updateTag({ property: 'og:title', content: data[0].meta_title });
        this.meta.updateTag({ name: 'keywords', content: data[0].meta_keyword });
        this.meta.updateTag({ name: 'description', content: data[0].meta_description });
        this.title.setTitle(data[0].meta_title);
        // console.log(data[0].meta_description)
      }

    })
    this.miceService.setCanonicalURL();
  }
  handleImageError(event: any) {
    event.target.src = '../../assets/img/kesari_logo.png';
  }
  openDialog(selectedCountry: string) {
    //console.log(selectedCountry, "asuigsauasudh");

    const dialogRef = this.dialog.open(EnquiryPopupComponent, {
      width: '900px',
      data: selectedCountry,
      disableClose: true,
      hasBackdrop: true
    });


  }

}
